module.exports = __webpack_public_path__ + "static/media/percentage_blue.59e58442.svg";